import { Link } from "react-router-dom";
import { track } from "../lib/api";

export default function CtaLink({ to, className = "", children, testid, event, ...rest }) {
  const onClick = () => { if (event) track(event.name, event.props || {}); };
  if (to.external) {
    return <a href={to.href} target={to.href.includes("calendly") ? "_blank" : undefined} rel="noopener noreferrer" className={className} data-testid={testid} onClick={onClick} {...rest}>{children}</a>;
  }
  return <Link to={to.href} className={className} data-testid={testid} onClick={onClick} {...rest}>{children}</Link>;
}

export const btnPrimary = "inline-flex items-center justify-center h-12 px-6 rounded-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold text-sm transition-colors";
export const btnDark = "inline-flex items-center justify-center h-12 px-6 rounded-full bg-slate-900 hover:bg-slate-800 text-white font-semibold text-sm transition-colors";
export const btnOrange = "inline-flex items-center justify-center h-12 px-6 rounded-full bg-orange-500 hover:bg-orange-600 text-white font-semibold text-sm transition-colors";
export const btnOutline = "inline-flex items-center justify-center h-12 px-6 rounded-full border border-slate-300 bg-white hover:bg-slate-50 text-slate-800 font-semibold text-sm transition-colors";
